/* assets/ba-gwp.js — Free ear-pad Gift-With-Purchase (GWP) engine.
   WHAT: Watches the cart and keeps a matching-colour Everyday + Cooling Gel pad
         set (free, line-property _gwp) present for every "parent" (Pump X) line —
         added when a parent enters the cart, quantity-synced, and removed when the
         parent leaves. Applies the GWP discount code (build phase) and refreshes
         the drawer via the theme's get_cart().
   WHY:  Reconciler approach — decoupled from the ATC button (this theme's button
         is NOT inside the product form and shares a duplicate id with the stock
         indicator, so click-interception is unreliable). Instead it reacts to ANY
         cart mutation (jQuery ajax, fetch, or XHR) plus page load.
   WHEN: 2026-07-14. Draft theme 130746744965 only; live untouched.
   Config (layout/theme.liquid, gated on the parent being tagged):
     window.BA_GWP = { code, property, parentSkus[], parentSkuToId{}, skuToId{}, giftIds[] }
*/
(function () {
  var CFG = window.BA_GWP;
  if (!CFG || !CFG.skuToId) return;
  var SYNCING = false;

  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }); });
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function applyCode() { return CFG.code ? fetch('/discount/' + encodeURIComponent(CFG.code), { credentials: 'same-origin' }).then(function () {}).catch(function () {}) : Promise.resolve(); }
  function refresh() { if (typeof window.get_cart === 'function') { try { window.get_cart(); } catch (e) {} } }
  function isParentSku(sku) { return !!sku && Array.isArray(CFG.parentSkus) && CFG.parentSkus.indexOf(sku) !== -1; }
  function giftProps() { var p = {}; p[CFG.property] = 'pump-x'; return p; }

  /* Desired gift variant-id -> qty, derived from the parent lines in the cart. */
  function desired(cart) {
    var pq = {};
    cart.items.forEach(function (it) { if (isParentSku(it.sku)) pq[it.sku] = (pq[it.sku] || 0) + it.quantity; });
    var want = {};
    Object.keys(pq).forEach(function (psku) {
      ['-EAR-EV', '-EAR-CG'].forEach(function (suf) {
        var gid = CFG.skuToId[psku + suf];
        if (gid) want[gid] = (want[gid] || 0) + pq[psku];
      });
    });
    return want;
  }

  function syncGifts() {
    if (SYNCING) return;
    SYNCING = true;
    getCart().then(function (cart) {
      if (!cart || !cart.items) { SYNCING = false; return; }
      var want = desired(cart);                              // giftVariantId -> qty
      var have = {};                                         // giftVariantId -> {key, qty}
      cart.items.forEach(function (it) { if (it.properties && it.properties[CFG.property]) have[it.variant_id] = { key: it.key, qty: it.quantity }; });

      var addItems = [], changes = [];
      Object.keys(want).forEach(function (gid) {
        var w = want[gid], cur = have[gid];
        if (!cur && w > 0) addItems.push({ id: Number(gid), quantity: w, properties: giftProps() });   // missing -> add
        else if (cur && cur.qty !== w) changes.push({ id: cur.key, quantity: w });                     // wrong qty -> sync
      });
      cart.items.forEach(function (it) {                                                                // orphan gift -> remove
        if (it.properties && it.properties[CFG.property] && !want[it.variant_id]) changes.push({ id: it.key, quantity: 0 });
      });

      if (!addItems.length && !changes.length) { SYNCING = false; return; }
      var chain = Promise.resolve();
      if (addItems.length) chain = chain.then(function () { return post('/cart/add.js', { items: addItems }).catch(function () { return null; }); });
      changes.forEach(function (c) { chain = chain.then(function () { return post('/cart/change.js', { id: c.id, quantity: c.quantity }); }); });
      chain.then(function () { return applyCode(); }).then(function () { SYNCING = false; refresh(); }).catch(function () { SYNCING = false; });
    }).catch(function () { SYNCING = false; });
  }

  function schedule() { if (!SYNCING) setTimeout(syncGifts, 250); }
  function isCartMutation(u) { return typeof u === 'string' && /\/cart\/(add|change|update)/.test(u); }

  /* Triggers: page load + every cart mutation, however it's issued. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncGifts); else syncGifts();

  if (window.jQuery) {
    window.jQuery(document).ajaxComplete(function (e, xhr, s) { if (s && isCartMutation(s.url)) schedule(); });
  }
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var a0 = arguments[0]; var url = (typeof a0 === 'string') ? a0 : (a0 && a0.url) || '';
      var p = _fetch.apply(this, arguments);
      if (isCartMutation(url) && !SYNCING) { try { p.then(function () { schedule(); }).catch(function () {}); } catch (e) {} }
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__gwpUrl = u; return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () { if (isCartMutation(this.__gwpUrl) && !SYNCING) { this.addEventListener('loadend', function () { schedule(); }); } return _send.apply(this, arguments); };

  /* PDP: keep the callout colour label in sync with the selected variant. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'single-varient') {
      var label = document.querySelector('[data-ba-gwp-colour]');
      if (label && e.target.value) label.textContent = e.target.value;
    }
  });
})();
